import { t } from "@lingui/macro"

const getGuaranteedSuiteInfoContent = () => ({
    label: t`Guaranteed category`,
    tooltipDetails: t`Suite category is guaranteed and may be upgraded if available. Your suite number will be confirmed prior to embarkation.`,
})

export default getGuaranteedSuiteInfoContent
